<!-- Loading -->
<ng-container *ngIf="(assignmentCommunicationStateService.assignmentCommunicationSubject| async) == null">
    <div class="text-center">
        <span><i class="fa-solid fa-spinner fa-spin"></i></span>
    </div>
</ng-container>

<ng-container *ngIf="(assignmentCommunicationStateService.assignmentCommunicationSubject| async) as communicationModel">
    <div class="d-flex flex-column gap-3" *ngIf="communicationModel != null">
        <app-assignment-communication-notes *ngIf="assignmentCommunicationStateService.isNotesVisible | async"
            [assignmentId]="assignmentId"></app-assignment-communication-notes>
        <app-assignment-communication-update *ngIf="assignmentCommunicationStateService.isUpdateVisible | async"
            [assignmentId]="assignmentId"></app-assignment-communication-update>
        <app-assignment-communication-feedback [assignmentId]="assignmentId"></app-assignment-communication-feedback>
    </div>
</ng-container>